import { useState } from 'react';
import { supabase } from './supabase';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError('Invalid email or password. Please try again.');
      setLoading(false);
    } else {
      onLogin();
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>

        {/* Logo */}
        <div style={styles.logoWrap}>
          <div style={styles.logoPill}>
            <span style={styles.logoText}>Flatiron Meal Plan</span>
          </div>
        </div>

        <h1 style={styles.title}>FMP Dashboard</h1>
        <p style={styles.subtitle}>Sign in to manage your apps</p>

        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>EMAIL</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@flatironmealplan.com"
              style={styles.input}
              required
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>PASSWORD</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              style={styles.input}
              required
            />
          </div>

          {error && <p style={styles.error}>{error}</p>}

          <button
            type="submit"
            style={styles.btn}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p style={styles.footer}>© 2026 Flatiron Meal Plan</p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#111111',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
  },
  card: {
    background: '#1a1a1a',
    border: '1px solid #333',
    borderRadius: '20px',
    padding: '40px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
  },
  logoWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
  },
  logoPill: {
    background: '#ffffff',
    borderRadius: '30px',
    padding: '8px 20px',
  },
  logoText: {
    color: '#111',
    fontSize: '14px',
    fontWeight: '500',
  },
  title: {
    color: '#FFC220',
    fontSize: '26px',
    fontWeight: '500',
    textAlign: 'center',
    marginBottom: '6px',
  },
  subtitle: {
    color: 'rgba(255,255,255,0.4)',
    fontSize: '13px',
    textAlign: 'center',
    marginBottom: '28px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    color: '#666',
    fontSize: '10px',
    letterSpacing: '1.5px',
  },
  input: {
    background: '#222',
    border: '1px solid #333',
    borderRadius: '10px',
    color: '#fff',
    fontSize: '14px',
    padding: '12px 14px',
    outline: 'none',
    fontFamily: 'inherit',
  },
  error: {
    color: '#ff6b6b',
    fontSize: '13px',
    textAlign: 'center',
    margin: '0',
  },
  btn: {
    background: '#FFC220',
    color: '#111',
    border: 'none',
    borderRadius: '10px',
    padding: '14px',
    fontSize: '15px',
    fontWeight: '500',
    cursor: 'pointer',
    marginTop: '8px',
  },
  footer: {
    color: '#333',
    fontSize: '11px',
    textAlign: 'center',
    marginTop: '24px',
    marginBottom: '0',
  },
};